export enum KeyType {
  RSA = "rsa",
  Edwards = "ed25519",
  BLS = "bls12-381"
}
